import { useState } from "react";
import { useTranslation } from "react-i18next";

import ConfirmDialog from "../dialogTypes/ConfirmDialog";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import defineConf from "../../config/defineConf";
import apiClient from "../../lib/common/apiClient";
import failureKey from "../../lib/common/failureKey";

function ShipStateChangeButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, grid, title, refresh, onSuccess, onFailure, ...others } = props;

    const [ open, setOpen ] = useState(false);

    const [confirmMsg, setConfirmMsg] = useState();
    const [confirmData, setConfirmData] = useState();

    const onOpen = () => {
        
        setConfirmMsg (
            t("dialog.msg.MomSysShip.confirm.ship", {
            shipId: `${grid.selectedItems[0].shipId}`,
            orderBuyerId: `${grid.selectedItems[0].orderBuyerId}`,
            orderBuyerName: `${grid.selectedItems[0].orderBuyerName}`,
        })
    );
        setConfirmData ( grid.selectedItems[0]);

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onOk = () => {
        
        let form = new FormData();
        let json = {};
        
        if([defineConf.shipState.NOT_SHIP,defineConf.shipState.SHIP_PART_COMPLETE].includes(grid.selectedItems[0]?.shipState)) {

            json.shipState = defineConf.shipState.SHIP_COMPLETE;
            
        } else {

            json.shipState = defineConf.shipState.NOT_SHIP;

        }
        
        form.append("json", JSON.stringify(json));
        apiClient
            .patch(`/api/MomSysShip/${grid.selectedItems[0].shipId}`,form, {
            })
            .then((result) => {
                if (refresh) {
                    refresh.refresh();
                }
                onSuccess(result.data);
            })
            .catch((reason) => {
                onFailure(t(failureKey("update", reason.response?.status), { reason: reason.response ? reason.response.data : reason }));
            });
    }

    return (

        <>
            <CreateRecordButtonLayout 
                id={id+"confirm-button"} 
                onClick={onOpen} 
                createButtonName = {[defineConf.shipState.NOT_SHIP,defineConf.shipState.SHIP_PART_COMPLETE].includes(grid.selectedItems[0]?.shipState) ? "shipCompleted" : "shipNotCompleted"} 
                {...others}  
            />
            <ConfirmDialog
                id={id+"-delivery-confirm-dialog"}
                title={ schema ? t ( `dialog.title.${schema.name}.shipConfirm` ) : "" }
                msg={confirmMsg}
                data={confirmData}
                open={open}
                onClose={onClose}
                onOk={onOk}
                onCancel={onClose}
            />
        </>

    );
}

export default ShipStateChangeButton;

